import { useRef } from 'react';

import { delayedCallback } from '@gem/utils';
import type { IDelayedTimeout } from '@gem/utils';

import type { ISyncValidationParams, ValidationResult } from './hooks.types';

export const useSyncValidation = (): ((params: ISyncValidationParams) => ValidationResult) => {
  const wasModified = useRef(false);
  const timeout = useRef<IDelayedTimeout['current']>(null);

  return (params: ISyncValidationParams): ValidationResult => {
    const { meta, value, values, validate, errorToText, data } = params;

    if (wasModified.current) {
      return validate({
        value,
        values,
        errorToText,
        data,
      });
    }

    // we need to async validate at the first time typing
    return delayedCallback(timeout, () => {
      if (!wasModified.current) {
        wasModified.current = !!meta.modified;
      }

      return validate({
        value,
        values,
        errorToText,
        data,
      });
    });
  };
};
